import axios from "axios";
import { baseUrl } from "../../../../boot";

export const createGetInTouch = async (data) => {
  // console.log("cart form data ---- ", data);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/admin/customer/api/v1/get-touch-mail`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Get in touch", error);
    throw error; // Return the error for further handling
  }
};